import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {formValidatorFactory} from '../../utils';
import {Formik, FormikProps} from 'formik';
import {Auth, AuthError} from '../../models/authModel';
import BaseForm, {FormValues} from './private/BaseForm';

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class ChangePasswordForm extends React.Component<{}, {}> {
  public render() {
    const {isChangingPassword: loading, errors} = this._withInjectedProps.auth;
    const invalidCurrentPassword = errors.get(AuthError.CHANGE_PWD_CURRENT_PWD_INVALID);

    return (
      <Formik
        initialValues={this._initialValues}
        validate={formValidatorFactory(this._getValidationSchema)}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => (
          <BaseForm {...props} loading={loading} invalidCurrentPassword={Boolean(invalidCurrentPassword)} />
        )}
      />
    );
  }

  private get _initialValues() {
    return {currentPassword: '', newPassword: '', newPasswordConfirm: ''};
  }

  private _getValidationSchema = (values: FormValues) => {
    return Yup.object().shape({
      currentPassword: Yup.string().required('Please enter your current password.'),
      newPassword: Yup.string()
        .min(6, 'Password must be longer than 6 characters.')
        .required('Please enter a password.'),
      newPasswordConfirm: Yup.string()
        .oneOf([values.newPassword], 'Password confirmation must match.')
        .required('Please confirm your password.')
    });
  };

  private _handleSubmit = ({currentPassword, newPassword}: FormValues) => {
    this._withInjectedProps.auth.changePassword(currentPassword, newPassword);
  };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordForm/ChangePasswordForm.tsx